// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4d1b160","337":"1acca321","453":"7aefb9b6","455":"8dbb8977"}[chunkId] + ".chunk.js";
};